import { useState, useEffect } from 'react';
import { RefreshCw, X } from 'lucide-react';
import { useUpdateManager } from '../hooks/useUpdateManager';
import { UpdateScreen } from './UpdateScreen';

/**
 * Componente que detecta e aplica atualizações automaticamente
 * Funciona tanto com PWA quanto sem PWA
 */
export function PWAUpdatePrompt() {
  if (import.meta.env.DEV) {
    return null;
  }

  const { updateState, showUpdateScreen, applyUpdate, cancelUpdate, setShowUpdateScreen } = useUpdateManager();
  const [isDismissed, setIsDismissed] = useState(false);
  const [processedVersions, setProcessedVersions] = useState<Set<string>>(new Set());

  const currentVersion = document.querySelector('meta[name="app-version"]')?.getAttribute('content');
  const processedVersion = localStorage.getItem('app-version-processed');
  const isVersionProcessed = currentVersion && processedVersion === currentVersion;

  useEffect(() => {
    const processed = localStorage.getItem('app-version-processed');
    if (processed) {
      setProcessedVersions(new Set([processed]));
    }
  }, []);


  if (showUpdateScreen) {
    return (
      <UpdateScreen
        onComplete={() => {
          setShowUpdateScreen(false);
        }}
        onError={() => {
          setShowUpdateScreen(false);
        }}
      />
    );
  }
  
  if (!updateState.hasUpdate || isDismissed || isVersionProcessed) {
    return null;
  }

  return (
    <div className="fixed bottom-4 right-4 z-50 animate-slide-up">
      <div className="bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-lg shadow-xl p-4 min-w-[320px] max-w-md">
        <div className="flex items-start gap-3">
          <div className="flex-shrink-0">
            <div className="w-10 h-10 rounded-full bg-blue-100 dark:bg-blue-900/30 flex items-center justify-center">
              <RefreshCw className="w-5 h-5 text-blue-600 dark:text-blue-400" />
            </div>
          </div>
          <div className="flex-1">
            <h3 className="font-semibold text-gray-900 dark:text-white mb-1">
              Nova Versão Disponível
            </h3>
            <p className="text-sm text-gray-600 dark:text-gray-400 mb-3">
              {updateState.updateSource === 'version'
                ? 'Uma nova versão da aplicação foi detectada.'
                : 'Uma atualização do Service Worker está disponível.'}
            </p>
            <div className="flex gap-2">
              <button
                onClick={applyUpdate}
                className="flex-1 px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white text-sm font-medium rounded-lg transition-colors flex items-center justify-center gap-2"
              >
                <RefreshCw className="w-4 h-4" />
                Atualizar Agora
              </button>
              <button
                onClick={() => {
                  setIsDismissed(true);
                  cancelUpdate();
                  setTimeout(() => setIsDismissed(false), 5 * 60 * 1000);
                }}
                className="px-3 py-2 text-gray-600 dark:text-gray-400 hover:text-gray-800 dark:hover:text-gray-200 transition-colors"
                aria-label="Fechar"
              >
                <X className="w-5 h-5" />
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

